import type { ReactNode } from 'react';

interface EmptyStateProps {
    icon: ReactNode;
    title: string;
    description: string;
    bullets?: string[];
    actionLabel?: string;
    onAction?: () => void;
}

export default function EmptyState({
    icon,
    title,
    description,
    bullets,
    actionLabel,
    onAction
}: EmptyStateProps) {
    return (
        <div className="empty-state">
            <div className="empty-state__iconWrapper">
                {icon}
            </div>
            <h3 className="empty-state__title">{title}</h3>
            <p className="empty-state__desc">{description}</p>

            {bullets && bullets.length > 0 && (
                <ul className="empty-state__bullets">
                    {bullets.map((b, i) => (
                        <li key={i}>{b}</li>
                    ))}
                </ul>
            )}

            {actionLabel && onAction && (
                <button className="btn btn-primary" onClick={onAction} style={{ marginTop: '1.5rem' }}>
                    {actionLabel}
                </button>
            )}
        </div>
    );
}
